import { connectorApi } from 'api/connector/api'
import { useNavigate } from 'react-router-dom'
import { notifyError } from 'shared/errors'

export function useStopReloadSession() {
	const navigate = useNavigate()

	const [signOutMember, mutationOptions] =
		connectorApi.useStopMemberSessionMutation()

	return [
		() =>
			signOutMember()
				.unwrap()
				.then(() => navigate('/team/members'))
				.catch(notifyError),
		mutationOptions
	] as const
}
